export const SketchOptions = {
    None: 'None',
    MainBuildingWithGarage: 'Main Building With Detached Garage',
    MainBuildingOnly: 'Main Building Only',
    WholeStructure: 'Whole Structure',
    PartialStructure: 'Partial Structure (check customer notes)',
    Other: 'Other',
};
